$(document).ready(function(){
  $('.t4s-swatch__item').click(function(){
    var myvalue = $(this).data('value');
    switchTab(myvalue);
  });
});
$(window).on("load", function() {
  var myvalue="";
  $(".t4s-swatch__item").each(function() {
    if($(this).hasClass('is--selected')){
      myvalue = $(this).data('value');
    }
  });
  switchTab(myvalue);
});
function switchTab(myvalue){
      if(myvalue.indexOf("Plush") >= 0){
      //Create your own
      $('#b_tab_html_YVgLW7').click();
      $('#b_tab_html_YVgLW7').addClass("t4s-active");
      $('#b_tab_html_B9bC8W').removeClass("t4s-active");
      //customizable
      $('#b_tab_liquid_Vfgdim').click();
      $('#b_tab_liquid_Vfgdim').addClass("t4s-active");
      $('#b_tab_html_r7D9iE').removeClass("t4s-active");
      //default
      $('#b_tab_html_4YiAV3').click();
      $('#b_tab_html_4YiAV3').addClass("t4s-active");
      $('#b_tab_html_wwqmPz').removeClass("t4s-active");
      //footballer
      $('#b_tab_html_YRUqrh').click();
      $('#b_tab_html_YRUqrh').addClass("t4s-active");
      $('#b_tab_html_bH3KtY').removeClass("t4s-active");  
      
    }else{
      //create your own
      $('#b_tab_html_B9bC8W').click();
      $('#b_tab_html_B9bC8W').addClass("t4s-active");
      $('#b_tab_html_YVgLW7').removeClass("t4s-active");
      //customizable
      $('#b_tab_html_r7D9iE').click();
      $('#b_tab_html_r7D9iE').addClass("t4s-active");
      $('#b_tab_html_D3bcKT').removeClass("t4s-active");
      //default
      $('#b_tab_html_wwqmPz').click();
      $('#b_tab_html_wwqmPz').addClass("t4s-active");
      $('#b_tab_html_4YiAV3').removeClass("t4s-active");  
      //footballer
      $('#b_tab_html_bH3KtY').click();
      $('#b_tab_html_bH3KtY').addClass("t4s-active");
      $('#b_tab_html_YRUqrh').removeClass("t4s-active");  
    }
}